/**
 * The route pattern for a path, as sent to Google Analytics instead of the real URL.
 * Real URLs carry the client search (?q=surname) and record IDs, which must not leave the app.
 */
const STATIC = new Set(['/clients', '/clients/new', '/renewals', '/account', '/staff', '/login', '/forgot-password', '/no-access']);

export function routePattern(pathname: string): string {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (STATIC.has(path)) return path;
  if (/^\/clients\/[^/]+$/.test(path)) return '/clients/:id';
  return '/other';
}
